<template>
  <textarea
    :class="rootClassName"
    :value="value"
    :rows="rowHeight"
    :disabled="disabled"
    :placeholder="placeholder"
    @input="$emit('input', $event.target.value)"
  ></textarea>
</template>

<script>
export default {
  name: 'Textarea',

  props: {
    value: {
      type: String,
      resize: {
        type: [Boolean, String],
        default: false,
        validator(val) {
          if (typeof val === 'boolean') { return true }
          if (typeof val === 'string') { return ['x', 'y', 'none'].includes(val) }
        }
      }
    },

    rowHeight: {
      type: Number,
      default: 3
    },

    fullWidth: Boolean,
    placeholder: String,
    disabled: Boolean
  },

  computed: {
    rootClassName() {
      return [
        this.$style.Textarea,
        this.resizeClassName,
        {
          'w-full': this.fullWidth,
          [this.$style.disabled]: this.disabled
        }
      ]
    },

    resizeClassName() {
      if (typeof this.resize === 'boolean') {
        return this.resize ? 'resize' : 'resize-none'
      } else {
        return `resize-${this.resize}`
      }
    }
  }
}
</script>

<style module>
.Textarea {
  @apply outline-none
    p-2
		font-medium
		text-base
    text-secondary
    border
		border-solid
		border-dull
    rounded;
}
.Textarea:focus {
  @apply border-primary;
}
.disabled {
  @apply opacity-50 cursor-not-allowed;
}
</style>